import React from 'react';
import PropTypes from 'prop-types';
import * as styled from './styles';
import { Link } from 'gatsby';
import get from 'lodash/get';
import { Swirl } from '../../vector';

function RoundedSimpleCards(props) {
  const {
    colorTheme,
    cards,
  } = props;

  return (
    <styled.Wrapper colorTheme={colorTheme}>
      <styled.Inner colorTheme={colorTheme}>
        <styled.Content>
          <styled.Cards>
            {cards.map((card) => {
              const linkTo = `${card.route ? get(card, 'route.slug.current') : card.link}${card.linkAnchor || ''}`;

              const cardContent = (
                <>
                  {card.image ? (
                    <styled.Image
                      edge={0}
                      altText={card.image.altText}
                      fluid={get(card, 'image.asset.fluid')}
                      loading="eager"
                    />
                  ) : null}
                </>
              );

              return (
                <styled.Card colorTheme={card.colorTheme} transparent={card.isTransparent}>
                  {linkTo ? (
                    <Link to={linkTo} key={card.title || linkTo}>
                      {cardContent}
                      <styled.CardData>
                        <styled.CardTitle level={300}>{card.title}</styled.CardTitle>
                        {card.label && <styled.Link level={400}><span>{card.label} ></span></styled.Link>}
                      </styled.CardData>
                    </Link>
                  ) : (
                    <React.Fragment key={card.title || 'no-link'}>{cardContent}</React.Fragment>
                  )}
                </styled.Card>
              );
            })}
          </styled.Cards>
        </styled.Content>
        <Swirl />
      </styled.Inner>
    </styled.Wrapper>
  );
}

RoundedSimpleCards.propTypes = {
  cards: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    title: PropTypes.string,
    image: PropTypes.object,
    link: PropTypes.string,
    linkAnchor: PropTypes.string,
    route: PropTypes.shape({
      slug: PropTypes.shape({
        current: PropTypes.string,
      }),
    }),
  })),
  colorTheme: PropTypes.oneOf(['dark-blue', 'green', 'orange', 'dark-purple', 'white']),
};

RoundedSimpleCards.defaultProps = {
  colorTheme: 'dark-blue',
};

export default RoundedSimpleCards;
